import React from 'react';

const PricingSection = () => {
  return (
    <section data-screen-label="Plans" style={{ padding: 'clamp(40px, 4.5vw, 64px) clamp(16px, 4vw, 48px)', background: '#FBFAF6', textAlign: 'left' }}>
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '36px',
          alignItems: 'center',
        }}
      >
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
          <span
            style={{
              fontSize: '11px',
              fontWeight: 800,
              letterSpacing: '2px',
              color: '#B5652E',
              border: '1px solid #E1C6A3',
              borderRadius: '999px',
              padding: '5px 14px',
            }}
          >
            PRICING
          </span>
          <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(22px, 4vw, 32px)', color: '#26332C', margin: 0, fontWeight: 800 }}>
            Two Advisory Plans, No Hidden Fees
          </h2>
          <p style={{ margin: 0, fontSize: '15px', color: '#5C574C' }}>
            Tailored to your compliance needs — both plans include advisory on corporate tax obligations.
          </p>
        </div>

        <div className="pricing-grid">
          {/* Card 1 */}
          <div
            style={{
              border: '1px solid #E4DCCC',
              borderRadius: '14px',
              padding: '28px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              background: '#FBFAF6',
            }}
          >
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '17px', fontWeight: 700, color: '#26332C' }}>
              Return Preparation
            </div>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '34px', fontWeight: 800, color: '#26332C' }}>
              AED 750 <span style={{ fontSize: '13px', fontWeight: 600, color: '#8A8377' }}>+ VAT</span>
            </div>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px', lineHeight: 1.5, color: '#39362F' }}>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Advisory on corporate tax obligations
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Eligibility &amp; exemption assessment
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Preparation &amp; review of your annual return
              </li>
            </ul>
            <a
              href="https://wa.me/971542119784"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                marginTop: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                background: 'transparent',
                border: '1.5px solid #26332C',
                color: '#26332C',
                borderRadius: '8px',
                padding: '12px',
                fontWeight: 700,
                fontSize: '14px',
                textDecoration: 'none',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#26332C';
                e.currentTarget.style.color = '#FBFAF6';
                const img = e.currentTarget.querySelector('img');
                if (img) img.style.filter = 'brightness(0) invert(1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#26332C';
                const img = e.currentTarget.querySelector('img');
                if (img) img.style.filter = 'brightness(0) contrast(1)';
              }}
            >
              <img
                src="/whatsapp-1.png"
                alt="WhatsApp"
                style={{
                  width: '16px',
                  height: '16px',
                  objectFit: 'contain',
                  filter: 'brightness(0) contrast(1)',
                  transition: 'filter 0.2s',
                }}
              />
              WhatsApp Us
            </a>
          </div>

          {/* Card 2 */}
          <div
            style={{
              border: '1.5px solid #B5652E',
              borderRadius: '14px',
              padding: '28px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              background: '#FDFAF3',
              position: 'relative',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '-12px',
                right: '24px',
                background: '#B5652E',
                color: '#FBFAF6',
                fontSize: '11px',
                fontWeight: 800,
                letterSpacing: '1px',
                borderRadius: '999px',
                padding: '5px 12px',
              }}
            >
              MOST POPULAR
            </div>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '17px', fontWeight: 700, color: '#26332C' }}>
              Preparation + Computation
            </div>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '34px', fontWeight: 800, color: '#26332C' }}>
              AED 1,500 <span style={{ fontSize: '13px', fontWeight: 600, color: '#8A8377' }}>+ VAT</span>
            </div>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px', lineHeight: 1.5, color: '#39362F' }}>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Everything in Return Preparation
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Full tax computation &amp; payable review
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Review of financials &amp; adjustments
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#2BAA5E', fontWeight: 'bold' }}>✓</span>Dedicated tax expert + WhatsApp support
              </li>
            </ul>
            <a
              href="https://wa.me/971542119784"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                marginTop: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                background: '#2BAA5E',
                color: '#FBFAF6',
                borderRadius: '8px',
                padding: '12px',
                fontWeight: 800,
                fontSize: '14px',
                textDecoration: 'none',
                transition: 'background 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#23934F';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#2BAA5E';
              }}
            >
              <img
                src="/whatsapp-1.png"
                alt="WhatsApp"
                style={{
                  width: '16px',
                  height: '16px',
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)',
                }}
              />
              WhatsApp Us
            </a>
          </div>
        </div>
        <p style={{ margin: 0, fontSize: '12.5px', color: '#8A8377', maxWidth: '64ch', textAlign: 'center' }}>
          Our services are advisory and preparation. All submissions are made by the client or their authorized signatory via the relevant government portals.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
